<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />

        <action-button type="save" @click="save" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md6 xs12>
                <v-autocomplete
                  name="moduleoption.moduletemplate_id"
                  v-model="moduleoption.moduletemplate_id"
                  :items="moduletemplates"
                  item-text="name"
                  item-value="id"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('moduleoptions.moduletemplate_id')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('moduleoption.moduletemplate_id')"
                  :readonly="true"
                  :disabled="true"
                ></v-autocomplete>
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  name="moduleoption.name"
                  v-model="moduleoption.name"
                  class="required-field"
                  v-validate="'required|max:100'"
                  :label="$t('moduleoptions.name')"
                  :error-messages="errors.collect('moduleoption.name')"
                  :readonly="!(allow_edit && allow_edit_from_admin)"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md2 sm6 xs12 v-if="course_type == 1 || course_type == null">
                <v-text-field
                  name="moduleoption.price"
                  v-model="computedPrice"
                  @keypress="$keyDown_PriceOnly($event)"
                  :hint="'Format:' + PRICE_FORMAT"
                  :label="$t('moduleoptions.price')"
                  :error-messages="errors.collect('moduleoption.price')"
                  :readonly="!allow_edit"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md2 sm6 xs12>
                <v-text-field
                  name="moduleoption.hours"
                  v-model="moduleoption.hours"
                  v-validate="'decimal'"
                  :label="$t('moduleoptions.hours')"
                  :error-messages="errors.collect('moduleoption.hours')"
                  :readonly="!(allow_edit && allow_edit_from_admin)"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 sm6 xs12>
                <v-select
                  name="moduleoption.select_visibility"
                  v-model="moduleoption.select_visibility"
                  item-text="text"
                  item-value="key"
                  :items="select_visibility_choices"
                  :label="$t('moduletemplates.select_visibility')"
                  :error-messages="errors.collect('moduleoption.select_visibility')"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg4 md4 sm6 xs12>
                <v-checkbox
                  name="moduleoption.enrol_select"
                  v-model="moduleoption.enrol_select"
                  :error-messages="errors.collect('moduleoption.enrol_select')"
                  :readonly="!allow_edit || disable_enrol_select"
                >
                  <template slot="label">
                    {{ $t("moduleoptions.enrol_select") }}
                    <span class="ml-1"
                      ><help-text slot="append" :tooltip="$t('moduleoptions.enrol_select_disable')" v-if="disable_enrol_select"
                    /></span>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex lg4 md4 sm6 xs12>
                <v-checkbox
                  name="moduleoption.mandatory_accomplishment"
                  v-model="moduleoption.mandatory_accomplishment"
                  :error-messages="errors.collect('moduleoption.mandatory_accomplishment')"
                  :readonly="disable_accomp_select"
                >
                  <template slot="label">
                    {{ $t("moduleoptions.mandatory_accomplishment") }}
                    <span class="ml-1"
                      ><help-text slot="append" :tooltip="$t('moduleoptions.accomp_select_disable')" v-if="disable_accomp_select"
                    /></span>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  name="moduleoption.comment"
                  v-model="moduleoption.comment"
                  rows="1"
                  auto-grow
                  :label="$t('moduleoptions.comment')"
                  :error-messages="errors.collect('moduleoption.comment')"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "ModuleOptionForm",

  props: [
    "id",
    "modal",
    "moduletemplate_id",
    "course_type",
    "from_module",
    "disable_enrol_select",
    "disable_accomp_select",
    "had_accomplishment_completed",
    "select_visibility"
  ],

  data() {
    return {
      api_module: "moduleoption",
      allow_edit_from_admin: false,
      allow_edit: false,
      allow_delete: false,
      page_title: "",
      predata: {},
      moduleoption: {},
      coursetemplates: [],
      moduletemplates: [],
      select_visibility_choices: this.$dd_select_visibility(),
      dictionary: {
        attributes: {
          "moduleoption.moduletemplate_id": this.$t("moduleoptions.moduletemplate_id"),
          "moduleoption.name": this.$t("moduleoptions.name"),
          "moduleoption.price": this.$t("moduleoptions.price"),
          "moduleoption.enrol_select": this.$t("moduleoptions.enrol_select"),
          "moduleoption.hours": this.$t("moduleoptions.hours"),
          "moduleoption.comment": this.$t("moduleoptions.comment"),
          "moduleoption.select_visibility": this.$t("moduletemplates.select_visibility")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.moduleoption, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedPrice: {
      get() {
        return this.$priceFormatGetter(this.moduleoption.price)
      },
      set(val) {
        this.$set(this.moduleoption, "price", this.$priceFormatSetter(val))
      }
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (this.from_module == "course") {
      this.api_module = "coursemoduleoption"
    }

    let lists = [
      {
        key: "moduletemplates",
        module: this.from_module == "course" ? "coursemoduletemplates" : "moduletemplates",
        query: "show_all=true&resourcetype=moduletemplate-ddlist"
      }
    ]

    axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
      this.coursetemplates = res.data.coursetemplates
      this.moduletemplates = res.data.moduletemplates

      if (!this.id) {
        this.moduleoption = {
          moduletemplate_id: this.moduletemplate_id
        }

        // JSON stringify and parse to remove variable reactiveness
        this.predata = JSON.parse(JSON.stringify(this.moduleoption))

        if (this.disable_accomp_select) {
          this.moduleoption.mandatory_accomplishment = false
        }

        if (this.disable_enrol_select) {
          this.moduleoption.enrol_select = false
        }

        this.setReadOnly()
        this.setPageTitle()
        this.filterSelectVisibility()
      } else {
        axios
          .get(this.API_URL + this.api_module + "/" + this.id)
          .then((res) => {
            this.moduleoption = res.data.data

            // JSON stringify and parse to remove variable reactiveness
            this.predata = JSON.parse(JSON.stringify(this.moduleoption))

            if (this.disable_accomp_select) {
              this.moduleoption.mandatory_accomplishment = false
            }

            if (this.disable_enrol_select) {
              this.moduleoption.enrol_select = false
            }

            this.setReadOnly()
            this.setPageTitle()
            this.filterSelectVisibility()
          })
          .catch((err) => console.log(err))
      }
    })
  },

  methods: {
    filterSelectVisibility() {
      if (this.select_visibility) {
        if (this.select_visibility == "show-expertise") {
          this.select_visibility_choices = this.select_visibility_choices.filter(
            (i) => i.key != "show-course-certificate" && i.key != "both"
          )
        }
        if (this.select_visibility == "show-course-certificate") {
          this.select_visibility_choices = this.select_visibility_choices.filter((i) => i.key != "show-expertise" && i.key != "both")
        }
        if (this.select_visibility == "no-choice") {
          this.select_visibility_choices = this.select_visibility_choices.filter((i) => i.key == "no-choice")
        }
      }
    },
    setReadOnly() {
      if (this.$hasRole("system-developer")) {
        this.allow_edit = true
        this.allow_edit_from_admin = true
        this.allow_delete = true
        return
      }

      if (_.has(this.moduleoption, "id")) {
        this.allow_edit = this.$can("moduletemplate-edit")
        this.allow_edit_from_admin = !Number.isInteger(this.moduleoption.admin_id)

        this.allow_delete = this.$can("moduletemplate-delete")
      } else {
        this.allow_edit = true
        this.allow_edit_from_admin = true
        this.allow_delete = false
      }
    },
    setPageTitle() {
      if (_.has(this.moduleoption, "id")) {
        this.page_title = this.$t("moduleoptions.edit_moduleoption", {
          name: this.moduleoption.name
        })
      } else {
        this.page_title = this.$t("moduleoptions.new_moduleoption")
      }
    },
    courseGroupChange(groupId) {
      axios.get(this.API_URL + "coursetypes?show_all=true&query_coursetypegroup_id=" + groupId).then((res) => {
        this.coursetypes = res.data.data
      })
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            if (!this.moduleoption.id) {
              if (this.had_accomplishment_completed && this.moduleoption.mandatory_accomplishment) {
                this.$awn.confirm(
                  this.$t("attendees.accomplishment_mandatory_addedupdated_confirm"),
                  () => {
                    this.createRecord(true)
                  },
                  () => {
                    this.$emit("return_modal_cancel_form")
                  },
                  {
                    labels: {
                      confirm: this.$t("global.confirm_message"),
                      confirmOk: this.$t("global.yes"),
                      confirmCancel: this.$t("global.no")
                    }
                  }
                )
              } else {
                this.createRecord(false)
              }
            } else {
              if (
                this.had_accomplishment_completed &&
                !this.predata.mandatory_accomplishment &&
                this.moduleoption.mandatory_accomplishment
              ) {
                this.$awn.confirm(
                  this.$t("attendees.accomplishment_mandatory_addedupdated_confirm"),
                  () => {
                    this.updateRecord(true)
                  },
                  () => {
                    this.$emit("return_modal_cancel_form")
                  },
                  {
                    labels: {
                      confirm: this.$t("global.confirm_message"),
                      confirmOk: this.$t("global.yes"),
                      confirmCancel: this.$t("global.no")
                    }
                  }
                )
              } else {
                this.updateRecord(false)
              }
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    createRecord(updateaccomplishment = false) {
      let vm = this
      axios
        .post(this.API_URL + this.api_module, {
          name: this.moduleoption.name,
          price: this.moduleoption.price,
          enrol_select: this.moduleoption.enrol_select,
          select_visibility: this.moduleoption.select_visibility,
          hours: this.moduleoption.hours,
          mandatory_accomplishment: this.moduleoption.mandatory_accomplishment,
          comment: this.moduleoption.comment,
          moduletemplate_id: this.moduleoption.moduletemplate_id
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            if (res.data.data.id) {
              if (!updateaccomplishment) {
                vm.$awn.success(vm.$t("global.create_success"))
              }

              if (vm.modal) {
                vm.$emit("return_modal_form", {
                  module: "moduleoption",
                  mode: "add",
                  data: res.data.data,
                  updateaccomplishment: updateaccomplishment
                })
              } else {
                vm.$router.replace(this.BACKEND_URL + `/moduleoptions/edit/${res.data.data.id}`).catch(() => {})
              }
            }
          }
        })
        .catch((err) => console.log(err))
    },
    updateRecord(updateaccomplishment = false) {
      let vm = this
      axios
        .put(this.API_URL + this.api_module, {
          id: this.moduleoption.id,
          name: this.moduleoption.name,
          price: this.moduleoption.price,
          enrol_select: this.moduleoption.enrol_select,
          select_visibility: this.moduleoption.select_visibility,
          hours: this.moduleoption.hours,
          mandatory_accomplishment: this.moduleoption.mandatory_accomplishment,
          comment: this.moduleoption.comment,
          moduletemplate_id: this.moduleoption.moduletemplate_id
        })
        .then((res) => {
          if (!updateaccomplishment) {
            vm.$awn.success(vm.$t("global.update_success"))
          }

          if (vm.modal) {
            vm.$emit("return_modal_form", {
              module: "moduleoption",
              mode: "edit",
              data: res.data.data,
              updateaccomplishment: updateaccomplishment
            })
          }
        })
        .catch((err) => console.log(err))
    }
  }
}
</script>

<style scoped></style>
